const backendUrl="https://webapi-portalplus.azurewebsites.net";

//const backendUrl="https://localhost:7209";

export default backendUrl;